import * as React from 'react';

import { ESuburbanWCType } from '../../../types/jsonQuery';
import { getTermValue } from '../../../../../JsonQuery';
import { useContext } from '../../../utils/useContext';
import { SuburbanBathroom } from '../../../components/advancedFilters/SuburbanBathroom';

export const SuburbanBathroomContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const suburbanBathroomType = getTermValue('wc_site')(jsonQuery);

  const handleChange = React.useCallback(
    (suburbanBathroomType: ESuburbanWCType | null) => {
      onChange({ action: 'setSuburbanBathroomType', arguments: [suburbanBathroomType] });
    },
    [onChange],
  );

  return <SuburbanBathroom value={suburbanBathroomType} onChange={handleChange} />;
};
